(function () {
  angular.module('kareo.ui.shared.directives.choose-kmb-document', [
    'angularModalService',
    'kareo.ui.shared.directives.choose-kmb-document-dialog'])
  .directive('kmbBatchUpload', kmbBatchUpload)
  .run(['$templateCache', function ($templateCache) {
    $templateCache.put('templates/choose-document-dialog/kmb-batch-upload/kmb-batch-upload.html', require('./kmb-batch-upload.pug')());
  }]);

  function kmbBatchUpload() {
    return {
      restrict: 'A',
      template: '<span ng-click=\'docUploadCtrl.openChooseDocumentDialog()\' class=\'ui-button-text\'>+ Upload Billing Document</span>',
      controller: kmbBatchUploadController,
      bindToController: true,
      controllerAs: 'docUploadCtrl'
    };
  }

  kmbBatchUploadController.$inject = ['ModalService'];
  function kmbBatchUploadController(ModalService) {
    var onDocumentModalClose;
    const ctrl = this;
    ctrl.openChooseDocumentDialog = openChooseDocumentDialog;
    ctrl.setDocumentModalCloseCallback = setDocumentModalCloseCallback;

    function openChooseDocumentDialog() {
      ModalService.showModal({
        template: require('./choose-kmb-document-dialog.pug')(),
        controller: 'ChooseKmbDocumentCtrl',
        controllerAs: 'kmbDocumentCtrl',
        inputs: {
          config: {
            isModalDialog: true
          }
        }
      }).then((modal) => {
        modal.close.then((documentReference) => {
          if (documentReference) {
            ctrl.document = documentReference;
          }
          if (onDocumentModalClose) {
            onDocumentModalClose(documentReference);
          }
        });
      });
    }

    function setDocumentModalCloseCallback(callbackFunc) {
      onDocumentModalClose = callbackFunc;
    }
  }
})();
